// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"show_thumbnail__1FTNV","title":"show_title__1CouS","memo":"show_memo__1CDV2"};